import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { PublicationCodes } from '@/scopes/common/domain/models'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import styles from './DestinationMoreInfo.module.css'
import { sanitizeContentNl } from './utils'

const POINTS_OF_INTEREST_TITLE_KEY = {
  summer: 'accommodation_page_destination_points_of_interest_title_summer',
  winter: 'accommodation_page_destination_points_of_interest_title_winter',
} as const

export default function DestinationMoreInfo() {
  const intl = useIntl()
  const info = useCMSPageField('PDP.surroundings')
  const sanitizedContent = sanitizeContentNl(info)
  const publicationCode = useConfiguration('publicationCode')
  const season = PublicationCodes.isSunwebWinterPublicationCode(publicationCode) ? 'winter' : 'summer'

  if (sanitizedContent.length === 0) {
    return null
  }

  return (
    <div className={styles.box}>
      <Typography as="h3" variant="display-h-regular">
        {intl.formatMessage({ id: POINTS_OF_INTEREST_TITLE_KEY[season] })}
      </Typography>
      <ul className={styles.list}>
        {sanitizedContent.map(item => (
          <Typography as="li" variant="body-m-regular-snug" key={item}>
            {item}
          </Typography>
        ))}
      </ul>
    </div>
  )
}
